// src/components/columns.js
import { Avatar, Chip, Tooltip } from '@mui/material';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import GridCellExpand from '../components/DataGridTooltips.jsx';

const employeesColumns = [
    {
        field: 'photo_url',
        headerName: '',
        width: 40,
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',width: '100%',
                    height: '100%', }}>
                    {params.row.suspended ? (
                        <Tooltip style={{ textSizeAdjust: 40 }} title='Suspended' placement='top' arrow>
                            <PersonOffIcon sx={{ fontSize: '40px', color: 'gray' }} />
                        </Tooltip>
                    ) : (
                        <Avatar src={params.value} sx={{ width: 40, height: 40 }} />
                    )}
                </div>
            );
        }

    },
    {
        field: 'full_name',
        headerName: 'Name',
        flex: 1,
        minWidth: 160,
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth}>
                    
                    <div style={{ display: 'flex', alignItems: 'center', alignContent: 'center', whiteSpace: 'nowrap', wordWrap: 'break-word', lineHeight: '1.5', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.row.suspended ? (
                            <Chip label='Suspended' variant='contained' sx={{ backgroundColor: '#f44336', color: 'white' }} style={{ marginLeft: '10px' }} />
                        ) : (
                            (params.row.is_gd_admin || params.row.is_delegated_admin) && (
                                <img style={{ alignContent: 'center', width: '20px', marginLeft: '10px' }} src='https://iili.io/Jazab4a.png' />
                            ))}
                    </div>

                </GridCellExpand>
            );
        }
    },
    {
        field: 'title',
        headerName: 'Title',
        minWidth: 160,
        flex: 1, 
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </GridCellExpand>
            );
        }
    },
    {
        field: 'department',
        headerName: 'Department',
        minWidth: 160,
        flex: 1, 
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </GridCellExpand>
            );
        }
    },
    {
        field: 'coach',
        headerName: 'Coach',
        minWidth: 160,
        flex: 1, 
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </GridCellExpand>
            );
        }
    },
    {
        field: 'work_location',
        headerName: 'Work Location',
        minWidth: 160,
        flex: 1, 
        headerClassName: 'header-class',
        renderCell: (params) => {
            return (
                <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth}>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {params.value}
                    </div>
                </GridCellExpand>
            );
        }
    },
    {
        field: 'phone',
        headerName: 'Contact Phone',
        flex: 1,
        sortable: false,
        headerClassName: 'header-class',
    }
];

export default employeesColumns;